<template>
  <div class="content-text">
    <h2 class="title-2 text-left">2 Componente Fixo</h2>
    <p>
      Este componente foi projetado considerando a vulnerabilidade social do
      município, assim como o seu tamanho populacional. O gestor pode sempre
      contar com ele, pois não varia. Ele também ajuda o gestor na implantação
      de novas equipes.
    </p>
    <h2 class="title-3 text-left">2.1 Implantação</h2>
    <p v-html="fixo.implantacao"></p>
    <h2 class="title-3 text-left">2.2 Custeio</h2>
    <p>
      Com classificação {{ dados.etapa3.ied.value }} no IED,
      <b
        >{{ dados.etapa1.cidade.no_municipio }} –
        {{ dados.etapa1.estado.uf }}</b
      >
      tem seu custeio mensal fixo definido conforme apresentado no Quadro 1, que
      mostra a quantidade de equipes, o valor por equipe e o valor total mensal
      por tipo de equipe.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 1 – Valor fixo de custeio por equipe
      </span>
      <table>
        <thead>
          <tr>
            <th>EQUIPES</th>
            <th>QUANTIDADE</th>
            <th>VALOR POR EQUIPE</th>
            <th>TOTAL POR EQUIPE</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in equipes.filter((el) => el.quantidade > 0)"
            :key="index"
          >
            <td>{{ item.label }}</td>
            <td class="text-right">
              {{ item.quantidade }}
            </td>
            <td class="text-right">
              R$
              {{ item.valorPorEquipe }}
            </td>
            <td class="text-right">
              R$
              {{ item.valorTotalPorEquipe }}
            </td>
          </tr>
          <tr>
            <td colspan="3">Total geral</td>
            <td class="text-right">R$ {{ totalGeral }}</td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>

    <p>
      Esse valor é depositado mensalmente e pode ser consultado de forma
      detalhada no
      <a
        href="https://consultafns.saude.gov.br/#/detalhada"
        target="_blank"
        style="text-decoration: none"
        >site</a
      >
      do Fundo Nacional de Saúde (FNS).
    </p>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    regras: {
      type: Object,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      equipes: [],
      totalGeral: 0,
    }
  },
  mounted() {
    this.formatarEquipes()
  },
  computed: {},
  methods: {
    formatarEquipes() {
      const ied = this.dados.etapa3.ied.value
      const valoresDasEquipesCusteio = this.regras.custeio.find(
        (item) => item.ied === ied
      )
      const equipesImplantadas = this.dados.etapa4
      if (equipesImplantadas != null) {
        valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
          let totalPorEquipe = 0
          let quantidadeDeEquipes = equipesImplantadas[element.label]
          totalPorEquipe += element.valor * quantidadeDeEquipes

          this.equipes.push({
            label: element.label,
            quantidade: quantidadeDeEquipes,
            valorPorEquipe: element.valor.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            }),
            valorTotalPorEquipe: totalPorEquipe.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            }),
          })

          this.totalGeral += totalPorEquipe
        })

        this.totalGeral = this.totalGeral.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })
      }
    },

    valorPorEquipe(tipoEquipe) {
      const ied = this.dados.etapa3.ied.value
      const valoresDasEquipesCusteio = this.regras.custeio.find(
        (item) => item.ied === ied
      )
      const valor = valoresDasEquipesCusteio.tipos_equipes.find(
        (el) => el.tipo == tipoEquipe
      )
      return valor.valor
    },
  },
}
</script>

<style lang="scss"></style>
